/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/Charges/Charge/Type/Content/AddInsuranceCode/Content/SaveAction",
  onSubmit,
  isSubmitting
  
}) {
let editChargeSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_charge',
})
let editChargeIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'edit_charge',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 data="edit_charge"
 onClick={editChargeSubmitData}
 disabled={editChargeIsSubmittingData}
 text="Save"
/>
{children}
</React.Fragment>)
}